import { FunctionComponent } from "react";
import { StyledBlock } from "./block.styles";
import Title from "components/title";

interface BlockProps {
  className?: string;
  title?: string;
  children: any;
}

const Block: FunctionComponent<BlockProps> = ({
  className,
  title,
  children,
}) => {
  return (
    <StyledBlock className={className}>
      {title && <Title level="h2">{title}</Title>}
      {children}
    </StyledBlock>
  );
};

export default Block;
